export const isImageUrl = (url) => /(http[s]?:\/\/.*\.(?:png|jpg))/i.test(url);
